import {EndpointEnum} from "../../constants/EndpointEnum";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import IStore from "../../models/IStore";
import * as EffectUtility from '../../utilities/EffectUtility';
import { ProductDetailsModel, ProductModel } from "../models/ProductModel";

export default class ProductEffect {
    public static async createProduct(state: IStore, model: any ):Promise<String | HttpErrorResponseModel> {
        return await EffectUtility.postToModel<String>(state, String, EndpointEnum.createProduct, model);
    }

    public static async getProductList(state: IStore):Promise<ProductModel | HttpErrorResponseModel> {
        return await EffectUtility.getToModel<ProductModel>(state, ProductModel, EndpointEnum.getProductList);
    }

    public static async deleteProduct(state: IStore, productId: string):Promise<String | HttpErrorResponseModel> {
        return await EffectUtility.deleteToModel<String>(state, String, EndpointEnum.deleteProduct.replace(':productId', productId));
    }

    public static async getProduct(state: IStore, productId: string):Promise<ProductDetailsModel | HttpErrorResponseModel> {
        return await EffectUtility.getToModel<ProductDetailsModel>(state, ProductDetailsModel, EndpointEnum.getProduct.replace(':productId', productId));
    }

    public static async updateProduct(state: IStore, model: ProductDetailsModel):Promise<String | HttpErrorResponseModel> {
        return await EffectUtility.putToModel<String>(state, String, EndpointEnum.updateProduct.replace(':productId', model.productId), model);
    }

    public static async exportProduct(state:IStore):Promise<any> {
          return EffectUtility.getToModel<Object>(state, Object, EndpointEnum.exportProduct);
    }
}